import { NgModule } from '@angular/core';
import {AuthModule} from 'abc';



@NgModule({
    imports  : [AuthModule],
    providers: [],
    exports: []
})
export class AbcModule {

}

